import { z } from "zod";

import { ArtifactSchema, ArtifactScopeSchema } from "./customer-context-schemas";
import { CustomerContextItemSchema } from "./customer-record-schemas";

export const RetrievalPageInputSchema = z.strictObject({
  scope: ArtifactScopeSchema.default({ kind: "customer" }),
  cursor: z.string().min(1).max(1024).nullable().default(null),
  limit: z.number().int().min(1).max(200).default(50),
});
export type RetrievalPageInput = z.infer<typeof RetrievalPageInputSchema>;
export const RetrievalPageSchema = z.strictObject({
  nextCursor: z.string().min(1).max(1024).nullable(),
  hasMore: z.boolean(),
});
export const ArtifactPageSchema = z.strictObject({
  artifacts: z.array(ArtifactSchema).max(200),
  page: RetrievalPageSchema,
});
export const NotePageSchema = z.strictObject({
  notes: z.array(CustomerContextItemSchema).max(200),
  page: RetrievalPageSchema,
});
export const SourceResponseSchema = z.strictObject({ artifact: ArtifactSchema.nullable() });
export const SearchSourcesResponseSchema = z.strictObject({
  sources: z
    .array(
      z.strictObject({
        artifact: ArtifactSchema,
        searchItemId: z.string().nullable(),
      }),
    )
    .max(50),
  counts: z.strictObject({
    total: z.number().int().nonnegative(),
    indexed: z.number().int().nonnegative(),
    pending: z.number().int().nonnegative(),
    failed: z.number().int().nonnegative(),
    unsupported: z.number().int().nonnegative(),
  }),
});
